import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { BrandData } from 'src/api';
import styles from './page-header.less';
import { NavLinkWithPad } from './nav-link-list';

interface LogoUrlProps {
    defaultNavUrl: string | undefined;
    brandData: BrandData | undefined;
}

export const DisplayLogo: React.SFC<LogoUrlProps> = (props) => {
    if (!props.brandData) {
        return null;
    }
    const defaultUrl = props.defaultNavUrl ? props.defaultNavUrl : '';
    return props.brandData.logoUrl ? (
        <NavLink
            to={defaultUrl}
            className={classnames(styles.logoImage, { [styles.disabled]: !defaultUrl })}
        >
            <img src={props.brandData.logoUrl} alt={props.brandData.officialName} />
        </NavLink>
    ) : (
        <NavLinkWithPad
            to={defaultUrl}
            className={classnames([
                'logo-text',
                styles.logoText,
                { [styles.disabled]: !defaultUrl },
            ])}
        >
            {props.brandData.officialName}
        </NavLinkWithPad>
    );
};
